import { Alert, Box } from "@mui/material";
import Loader from "components/Loader";
import RedirectBackButton from "components/RedirectBackButton";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import { FormattedMessage as T, useIntl } from "react-intl";
import { useQuery } from "react-query";
import { Navigate, useParams } from "react-router-dom";
import NotificationConfigurationForm, {
  NotificationConfigFormMode,
} from "./NotificationConfigurationForm";

const NotificationConfigurationEditForm = () => {
  const { formatMessage: t } = useIntl();
  const {
    notificationConfigurationDetailsUrl,
    notificationConfigurationsUrl,
    notificationsConfigurationsService,
  } = useGlobalContext();
  const { id } = useParams<{ id: string }>();

  const { data, isLoading, isError } = useQuery(
    ["notificationsConfigurationsService.getNotificationConfiguration", id],
    () => notificationsConfigurationsService.getNotificationConfiguration(id!),
    { enabled: !!id },
  );

  useTitle(t({ id: "editNotificationConfiguration" }));

  if (!id) return <Navigate to={notificationConfigurationsUrl()} replace />;
  if (isLoading) return <Loader />;
  if (isError || !data?.data) {
    return (
      <Box mt={4}>
        <Alert severity="error">
          <T id="fetchError" />
        </Alert>
      </Box>
    );
  }

  return (
    <Box>
      <RedirectBackButton
        redirectRoute={notificationConfigurationDetailsUrl(id)}
        labelKey="backToDetailsButtonLabel"
      />
      <h2>{t({ id: "editNotificationConfiguration" })}</h2>
      <NotificationConfigurationForm
        mode={NotificationConfigFormMode.Update}
        configuration={data.data}
      />
    </Box>
  );
};

export default NotificationConfigurationEditForm;
